import React, { useState } from "react";
import "./aboutus.css";
import { useCookies } from "react-cookie";
import axios from "axios";
import EditorToolbar, {
  modules,
  formats,
} from "../../../Components/EditorToolbar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { IoChevronDown, IoChevronForwardSharp } from "react-icons/io5";
import { BsChevronDoubleRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import UploadImg from "../../../Components/upload/UploadImg";

const Aboutus = ({ sendnotice }) => {
  const API = "https://staging.sabrecwa.com/staff";
  const [cookies] = useCookies(["Token"]);
  // const [tabimg, setTabimg] = useState(true)
  const [tabtext, setTabtext] = useState(true);

  const [aboutus, setAboutus] = useState("");
  const [aboutus_img_url, setAboutus_img_url] = useState("");
  const [previewclick, setPreviewclick] = useState(false);
  const [swipe, setSwipe] = useState(true);
  const [loaderror, setLoaderror] = useState({
    statusid: 0,
    message: "",
  });

  const [localurl, setLocalurl] = useState("");

  const handleswipe = () => {
    setSwipe(!swipe);
  };

  const handleExeClick = () => {};

  const handleTrademark = () => {};

  const handleAllianceClick = () => {};

  const handleAboutClick = async () => {
    // try{
    //   var config = {
    //     method: 'GET',
    //     url: 'https://admin.sabrecwa.com/backend/regions'
    //   };
    // await axios(config).then((response) => {
    // if(response.data.success === true){
    //   setAboutus(response.data.data)
    // }});}
    // catch(e){
    //   if(e.message.includes('401')){
    //     // console.log("error")
    //   }
    //   // console.log(e)
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    sendnotice({
      action: "load",
      text: "Uploading Data...",
    });

    try {
      var config = {
        method: "POST",
        url: `${API}/hr/create/about`,
        data: { brief_about: aboutus },
        headers: {
          Authorization: "Bearer " + cookies.Token,
        },
      };

      // console.log(config)

      await axios(config).then((response) => {
        // console.log(response)
        if (response.data.success === true) {
          // do something
          sendnotice({
            action: "notload",
            text: response.data.message,
          });
        }
      });
    } catch (e) {
      if (e.message.includes("401")) {
        // catch error
      } else {
        // catch error
      }
    }
  };

  const handleSocialFocus = () => {
    setPreviewclick(!previewclick);
  };

  const handledirectoryUpdate = (incoming) => {
    setAboutus_img_url(incoming);
  };

  const handleToggleSelection = () => {
    setLoaderror({
      statusid: 0,
      message: "",
    });
  };

  const handleabout_text_click = () => {
    setTabtext(!tabtext);
  };

  const localUrl_Funct = (incoming) => {
    setLocalurl(incoming);
    console.log(incoming);
  };

  return (
    <div className="appr-web-executive-container">
      <div className="exec_adduser_title">
        <span>About Us</span>
      </div>

      <UploadImg
        onfocus={handleToggleSelection}
        directory={handledirectoryUpdate}
        mylocalUrl={localUrl_Funct}
      />

      <div className="website-aboutus-container">
        <div className="website-exec-preview" onClick={handleabout_text_click}>
          <span>Add About Text</span>
          {tabtext ? (
            <IoChevronForwardSharp
              id="chevron-down"
              onClick={handleSocialFocus}
            />
          ) : (
            <IoChevronDown id="chevron-down" onClick={handleSocialFocus} />
          )}
        </div>

        <form
          onSubmit={handleSubmit}
          className={
            tabtext === false
              ? "website-exec-preview-abut"
              : "website-exec-preview-about"
          }
        >
          <div className="executive_about_img_area">
            <EditorToolbar toolbarId={"t2"} />
            <ReactQuill
              theme="snow"
              value={aboutus}
              onChange={setAboutus}
              className="executive-title"
              modules={modules("t2")}
              formats={formats}
            />
          </div>

          <div className="exec_adduser_body_row_1">
            <button type="submit" id="about_form_submit_butn">
              Submit
            </button>
          </div>
        </form>
      </div>

      <div className="website-exec-preview-container">
        <div className="website-exec-preview" onClick={handleSocialFocus}>
          <span>Web Preview</span>
          {previewclick ? (
            <IoChevronDown id="chevron-down" onClick={handleSocialFocus} />
          ) : (
            <IoChevronForwardSharp
              id="chevron-down"
              onClick={handleSocialFocus}
            />
          )}
        </div>

        <div
          className={
            previewclick === false
              ? "website_exec_preview_about"
              : "website_exec_preview_abut"
          }
        >
          <div className="cwa-contactus-img-container">
            <div className="cwa-contactus-img-container-overlay" />
            <img
              src={localurl}
              className="cwa-contactus-img"
              alt="background-images"
            />
            <div className="cwa-container-textbox">
              <div id="navigator">
                <span>Home &#187; About</span>
              </div>
              <span>About Us</span>
            </div>
          </div>

          <div className="blogpagee-container-bottm">
            <div
              className={
                swipe
                  ? "exec-left-div-blogpage"
                  : "exec-left-div-blogpage-swipe"
              }
            >
              <div className="exec-left-blog-category">
                <div
                  className="exec-left-blog-subcategory"
                  onClick={handleAboutClick}
                >
                  <span>ABOUT US</span>
                </div>

                <div
                  className="exec-left-blog-subcategory"
                  onClick={handleAllianceClick}
                >
                  <span>ALLIANCES</span>
                </div>

                <Link to="/contact-us" className="exec-left-blog-subcategory">
                  <Link to="/contact-us" className="contactus-icon">
                    <span>CONTACT US</span>
                  </Link>
                </Link>

                <div
                  className="exec-left-blog-subcategory"
                  onClick={handleExeClick}
                >
                  <span>EXECUTIVE TEAM</span>
                </div>

                <div
                  className="exec-left-blog-subcategory"
                  onClick={handleTrademark}
                >
                  <span>COPYRIGHT AND TRADEMARK</span>
                </div>
              </div>
            </div>
            <div className="ql-editor">
              <div dangerouslySetInnerHTML={{ __html: aboutus }} />
            </div>
          </div>

          <div className="chevron-right-exec-cont" onClick={handleswipe}>
            <BsChevronDoubleRight id="chevron-right-exec" />
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default Aboutus;
